import { TrendingUp, Shield, Smartphone, BookOpen } from "lucide-react";

/**
 * Affiliate Marketing Section
 * 
 * Add your affiliate links here for:
 * - Brokerage platforms (XP, Rico, Inter, Clear, etc)
 * - Financial courses
 * - Investment tools
 * - Books and resources
 * 
 * Commission: Usually 20-50% per sale or R$ 50-200 per signup
 */
const AffiliateSection = () => {
  const affiliateLinks = [
    {
      icon: TrendingUp,
      title: 'Corretora XP',
      description: 'Abra sua conta e invista com taxa zero',
      link: 'https://www.xpi.com.br',
      color: 'bg-blue-600',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=300&fit=crop',
      cta: 'Abrir Conta Grátis'
    },
    {
      icon: Shield,
      title: 'Rico Investimentos',
      description: 'Invista em renda fixa, ações e fundos',
      link: 'https://www.rico.com.vc',
      color: 'bg-orange-600',
      image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=400&h=300&fit=crop',
      cta: 'Começar a Investir'
    },
    {
      icon: Smartphone,
      title: 'Inter Invest',
      description: 'Banco digital com investimentos integrados',
      link: 'https://www.bancointer.com.br',
      color: 'bg-orange-500',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=300&fit=crop',
      cta: 'Criar Conta'
    },
    {
      icon: BookOpen,
      title: 'Curso de Analista Financeiro',
      description: 'Aprenda análise financeira profissional do zero ao avançado. Certificado reconhecido.',
      link: 'https://go.hotmart.com/R103310637O',
      color: 'bg-emerald-600',
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=300&fit=crop',
      cta: 'Acessar Curso',
      featured: true
    }
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-8 mb-12" data-testid="affiliate-section">
      <h2 className="text-2xl font-bold text-slate-900 mb-2">
        Recursos Recomendados
      </h2>
      <p className="text-slate-600 mb-6">
        Plataformas e ferramentas que recomendamos para seus investimentos
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {affiliateLinks.map((item, index) => {
          const Icon = item.icon;
          return (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className={`flex flex-col overflow-hidden border rounded-xl hover:shadow-lg transition-all group ${
                item.featured 
                  ? 'border-emerald-500 ring-2 ring-emerald-500/20' 
                  : 'border-slate-200 hover:border-emerald-500'
              }`}
              data-testid={`affiliate-link-${index}`}
              onClick={() => {
                // Track affiliate clicks
                if (window.gtag) {
                  window.gtag('event', 'affiliate_click', {
                    affiliate_name: item.title
                  });
                }
              }}
            >
              {/* Image */}
              <div className="relative h-40 overflow-hidden bg-slate-100">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className={`absolute top-3 left-3 w-10 h-10 ${item.color} rounded-lg flex items-center justify-center shadow-lg`}>
                  <Icon className="w-5 h-5 text-white" />
                </div>
                {item.featured && (
                  <div className="absolute top-3 right-3 bg-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                    DESTAQUE
                  </div>
                )}
              </div>
              
              {/* Content */}
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-bold text-slate-900 mb-2 group-hover:text-emerald-900 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-slate-600 mb-3 flex-1">{item.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-emerald-900">
                    {item.cta} →
                  </span>
                </div>
              </div>
            </a>
          );
        })}
      </div>

      <p className="text-xs text-slate-400 mt-4 text-center">
        Divulgação: Podemos receber comissão por cadastros através destes links
      </p>
    </div>
  );
};

export default AffiliateSection;